import React from 'react';
import { observer } from 'mobx-react';

import {
  TableContent,
  TableContentProps,
} from 'libs/connection/Table/TableContent';
import { TableBox } from 'libs/connection/Table';
import { Section, SectionContent } from '../../shared/layout';

// ShipmentProductQuotes -- ShipmentQuoteParts?
// Props are the same as TableContent props + title and Button
// but button could be implemented using TableActions?

interface TableSectionProps
  extends Omit<TableContentProps, 'showEmptyPlaceholder'> {
  title: string;
  Button?: React.ReactNode;
  isDivisorVisible?: boolean;
  warningMessage?: React.ReactNode;
  dataTestId?: string;
}

export const TableSection = observer(
  ({
    nodes,
    columns,
    loading,
    emptyTablePlaceholder = null,
    RowActionButtons,
    Button,
    title,
    isDivisorVisible = true,
    warningMessage,
    getHoveredComponent,
    shouldRowBeGreyedOut,
    dataTestId,
  }: TableSectionProps) => {
    return (
      <Section title={title}>
        <SectionContent
          sx={{ paddingTop: 0 }}
          isDivisorVisible={isDivisorVisible}
        >
          <TableBox
            wrapperStyle={{
              py: null,
              mx: null,
            }}
          >
            <TableContent
              nodes={nodes}
              dataTestId={dataTestId}
              columns={columns}
              loading={loading}
              getHoveredComponent={getHoveredComponent}
              showEmptyPlaceholder={!loading && nodes.length === 0}
              emptyTablePlaceholder={emptyTablePlaceholder}
              RowActionButtons={RowActionButtons}
              shouldRowBeGreyedOut={shouldRowBeGreyedOut}
              loadingRowCount={5}
            />
          </TableBox>
          {Button}
          {warningMessage}
        </SectionContent>
      </Section>
    );
  },
);
